import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IReportsList } from '../../interfaces';

export function useMonthlyUsageList(): IReportsList[] {
    return useContext(MobXProviderContext).RootStore.monthlyUsageStore.list;
}

export function useMonthlyUsageTotals(): { [key: string]: string } {
    return useContext(MobXProviderContext).RootStore.monthlyUsageStore.totals;
}
